import { TeachersUIProvider } from "./TeachersUIContext";
import { TeachersCard } from "./TeachersCard";

export function TeachersPage({
  history,
  noticeGroupId,
  receipentType
}) {
  return (
    <TeachersUIProvider teachersUIParameters={{ history, noticeGroupId, receipentType }}>
      <TeachersCard/>
    </TeachersUIProvider>
 );
}